export default __webpack_public_path__ + "static/media/Poseidon-light.74a3abe4.gif";